// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__zN0_Q","row":"ProcedureTreatmentSummary_row__1H5RC"};